// test2281
(2281 && 0);
